import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faCircleArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import React, { Fragment } from "react";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import "../App.scss";
import "./SubHeader.scss";
import { useWindowDimensions } from "../helper/useWindowDimensions";
import { useTranslation } from "react-i18next";

function SubHeader({ filterHandler, search }) {
  const windowDimensions = useWindowDimensions();

  const { t } = useTranslation();

  return (
    <Fragment>
      <Container>
        {!windowDimensions.isLarge && (
          <>
            <Row className="mx-4 my-3 ps-3 py-2">
              <Col md={6} sm={12}>
                <div className="searchbox-wrapper">
                  <div className="searchbox">
                    <input
                      type="text"
                      id="search"
                      className="input"
                      placeholder={t("subheader.search")}
                      value={search}
                      onChange={(e) => {
                        filterHandler(e.target.value);
                      }}
                    />
                    <Button
                      className="rounded-pill h-75 searchbtn"
                      variant="dark"
                    >
                      <FontAwesomeIcon icon={faSearch} />
                    </Button>
                  </div>
                </div>
              </Col>
              <Col md={6} sm={12}>
                <div
                  className="d-flex clickable go-to-condoleances pt-2"
                  onClick={() => {
                    // Go to external link in a new tab
                    window.open("https://condoleances.be/", "_blank");
                  }}
                >
                  <div className="flex-grow-1 text-end me-2">
                    <p className="mb-0 text-wrap">{t("subheader.filter")}</p>
                  </div>
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faCircleArrowRight}
                      style={{ fontSize: "1.5rem" }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </>
        )}
        {windowDimensions.isLarge && (
          <Row className="mx-4 my-3 ps-3 py-2">
            <Col sm={4}></Col>
            <Col sm={4} className="border-dark hide-border">
              <div className="searchbox-wrapper">
                <div className="searchbox">
                  <input
                    type="text"
                    id="search"
                    className="input"
                    placeholder={t("subheader.search")}
                    value={search}
                    onChange={(e) => {
                      filterHandler(e.target.value);
                    }}
                  />
                  <Button
                    className="rounded-pill h-75 searchbtn"
                    variant="dark"
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </Button>
                </div>
              </div>
            </Col>
            <Col sm={1}></Col>
            <Col sm={3}>
              <div
                className="d-flex clickable go-to-condoleances"
                onClick={() => {
                  // Go to external link in a new tab
                  window.open("https://condoleances.be/", "_blank");
                }}
              >
                <div className="flex-grow-1 text-end me-2">
                  <p className="mb-0 text-wrap">{t("subheader.filter")}</p>
                </div>
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon
                    icon={faCircleArrowRight}
                    style={{ fontSize: "1.5rem" }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        )}
      </Container>
      <Container>
        <hr />
      </Container>
    </Fragment>
  );
}

export default SubHeader;
